// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import donationReportEntity from './entities/donation-report.json';
import donationReportMenu from '../pages/donation-report/menu.json';
import donationReportFullForm from '../pages/donation-report/forms/full.json';
import donationReportContextForm from '../pages/donation-report/forms/context.json';
import donationReportMiniForm from '../pages/donation-report/forms/mini.json';
import donationReportLookupForm from '../pages/donation-report/forms/lookup.json';
import donationReportTableView from '../pages/donation-report/views/table.json';
import donationReportCardsView from '../pages/donation-report/views/cards.json';
import donationReportDashboardView from '../pages/donation-report/views/dashboard.json';

/** Тип запису «Фінансовий звіт» зі сторінками пакета: меню, форми та подання з pages/donation-report/. */
export const donationReportDefinition: IRecordTypeDefinition = {
  ...donationReportEntity,
  views: assembleViewSet({
      table: donationReportTableView,
      cards: donationReportCardsView,
      dashboard: donationReportDashboardView,
  }),
  form: donationReportFullForm,
  forms: { full: donationReportFullForm, context: donationReportContextForm, mini: donationReportMiniForm, lookup: donationReportLookupForm },
  menu: donationReportMenu,
} as IRecordTypeDefinition;
